import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { BANNER_CAROUSEL_BANNER } from './constants';
import { Root, Title } from './styles';
import { type BannerProps } from './types';

export const Banner: FC<BannerProps> = ({ onClick, title }) => {
  const { getTestId } = useTestId();

  return (
    <Root
      data-testid={getTestId(BANNER_CAROUSEL_BANNER)}
      onClick={onClick}
    >
      <Title fontWeight="bold">{title}</Title>
    </Root>
  );
};
